import { render } from "./SectionParentChildren.vue?vue&type=template&id=7fd8be09"
import script from "./SectionParentChildren.vue?vue&type=script&lang=js"
export * from "./SectionParentChildren.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dt/Sites/vues/foggyrealm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__